// export const serverurl = "http://localhost"
export const serverurl = "http://optimabk.ztools.ro"
